import {
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Fab,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import moment from "moment-timezone";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
import ReactSignatureCanvas from "react-signature-canvas";
import ShopS3PresignedCardImage from "../../../components/ShopS3PresignedCardImage";
import { CameraAlt, Close, Upload } from "@mui/icons-material";
import FileAttachment from "../../../components/FileUpload/FileAttachment";
import ShopS3PresignedImage from "../../../components/ShopS3PresignedImage";
import DownloadIcon from "@mui/icons-material/Download";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import getPickupPackingListDocDefinition from "../../../pdf-helpers/PickupPackingList";
import QRCode from "qrcode";
import OrderTitle from "../../../components/OrderTitle";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import PickupForm from "./PickupForm";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const EditPickup = () => {
  const { orderId, pickupId } = useParams();
  const { ezorder, authToken } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const theme = useTheme();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pickup, setPickup] = useState();
  const [pickupItems, setPickupItems] = useState();

  const getPickupDetails = async (orderId, pickupId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(
        `/shop/jobs/${orderId}/pickup-history/pickups/${pickupId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      setPickup(res.data.pickup);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const getOrderWithPickupHistory = async (orderId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/shop/jobs/${orderId}/pickup-history`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOrderDetails(res.data.order);
      let items = res.data.order.pickupHistory.items;
      setPickupItems(items);
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const updatePickup = async () => {
    try {
      setLoading(true);

      const response = await ezorder.put(
        `/shop/jobs/${orderId}/pickup-history/pickups/${pickupId}`,
        pickup,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Updated");
        navigate(-1);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((orderId, pickupId)) {
      getOrderWithPickupHistory(orderId);
      getPickupDetails(orderId, pickupId);
    }
  }, [orderId, pickupId]);

  return (
    <Box>
      {orderDetails && (
        <>
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box sx={{ flex: 1 }}>
                <OrderTitle order={orderDetails} includeLink={true} />
              </Box>
            </Box>
          </Box>
          {loading || !orderDetails ? (
            <Box
              sx={{
                width: "100%",
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size="3rem" />
            </Box>
          ) : (
            <Box>
              <Typography variant="h6">
                <Typography variant="h5" sx={{ textAlign: "center" }}>
                  Edit{" "}
                  {pickup && pickup.pickupType == "DELIVERY"
                    ? "Delivery"
                    : "Pickup"}{" "}
                  #{pickup ? pickup.id : ""}
                </Typography>
              </Typography>
              <PickupForm
                pickupItems={pickupItems}
                pickup={pickup}
                onUpdatePickup={(update) => {
                  setPickup((prev) => ({
                    ...prev,
                    ...update,
                  }));
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={() => {
                    navigate(`/job-pickups/${orderId}`);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    updatePickup();
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default EditPickup;
